define('models/commons/province',[
    'underscore',
    'backbone',
    // 'epoxy',
    // 'models/computed-model'
], function(_, Backbone) {

    var MProvince = Backbone.Epoxy.Model.extend({
        idAttribute: 'code',
        computeds: {
            label: function() {
                return this.get("name");
            },
            value: function() {
                return this.get("code");
            }
        }
        // urlRoot: "",
    });

    // Return the model for the module
    return MProvince;
});

